/**
 * Notifications popups
 */
$('.dropdown').on('click', 'a[data-popup-notifications]', function(e) {
    e.preventDefault();

    var popup = $($(this).data('popup-notifications'));
    popup.appendTo($('#popup-wrapper'));

    if ($('.popup:visible').length) {
        changePopup($($(this).data('popup-notifications')));
    } else {
        showPopup($($(this).data('popup-notifications')));
    }
});

/**
 * Notifications - set notifications as read
 */
function setUserNotificationsRead(user_id) {
    var token = $("#set_user_notifications_read_token").val();
    $.ajax({
        type: 'POST',
        url: "./../notifications/set_user_notifications_read",
        data: {
            'user_id': user_id,
            '_token': token,
        },
        success: function (data) {
            $("#user_notifications_in_header_li").html(data);
            $('.header-actions-button').removeClass('hasNotifications');
        },
        error: function () {
            alert('Error');
        }
    });
}

/** START **
 * Notifications - auto loading ajax scroll
 */
var notification_page_token_SdEFDSds1c = 0;

$('.popup-wrapper').scroll("#notifications-popup", function() {
    var user_notifications_count_all = $('#user_notifications_count_all').val();
    var user_notifications_num_per_page = $('#user_notifications_num_per_page').val();

    if(typeof notificaion_popup != "undefined") {
        if (user_notifications_count_all && user_notifications_num_per_page) {
            var sum_scroll_popup = $(window).height() + $('.popup-wrapper').scrollTop();
            if (sum_scroll_popup >= $('#popup_body').height() && user_notifications_count_all > (user_notifications_num_per_page * (notification_page_token_SdEFDSds1c - 1))) {
                notification_page_token_SdEFDSds1c++;
                loadMoreData(notification_page_token_SdEFDSds1c);

            }
        }
    }
});

function loadMoreData(notification_page) {
    $.ajax({
        url: './../notifications/autoload/?notification_page=' + notification_page,
        type: "get",
        beforeSend: function () {
            $('#notification_loading').show();
        }
    })
        .success(function (data) {
            if (data == "") {
            }
            else {
                $('#notification_popup_table tr:last').after(data);
            }
        })
        .error(function (jqXHR, ajaxOptions, thrownError) {
            alert('server not responding...');
        });
}
/** END ** Notifications - auto loading ajax scroll **/
